import { Card, CardContent } from "../../ui/card";
import { formatCurrency } from "../utils";

const BillingSummaryCards = ({ totalBilled, totalReceived, totalOutstanding, remainingToBill }) => {
  const showRemaining = remainingToBill !== null && remainingToBill !== undefined;

  return (
    <div className={`grid grid-cols-1 ${showRemaining ? "md:grid-cols-4" : "md:grid-cols-3"} gap-4`}>
      <Card className="bg-blue-50 border-blue-200">
        <CardContent className="pt-4">
          <p className="text-sm text-blue-700 font-medium">Total Billed</p>
          <p className="text-2xl font-bold text-blue-800">{formatCurrency(totalBilled, true)}</p>
        </CardContent>
      </Card>
      <Card className="bg-green-50 border-green-200">
        <CardContent className="pt-4">
          <p className="text-sm text-green-700 font-medium">Total Received</p>
          <p className="text-2xl font-bold text-green-800">{formatCurrency(totalReceived, true)}</p>
        </CardContent>
      </Card>
      <Card className="bg-amber-50 border-amber-200">
        <CardContent className="pt-4">
          <p className="text-sm text-amber-700 font-medium">Outstanding</p>
          <p className="text-2xl font-bold text-amber-800">{formatCurrency(totalOutstanding, true)}</p>
        </CardContent>
      </Card>
      {showRemaining && (
        <Card className={remainingToBill > 0 ? "bg-purple-50 border-purple-200" : "bg-gray-50 border-gray-200"}>
          <CardContent className="pt-4">
            <p className={`text-sm font-medium ${remainingToBill > 0 ? "text-purple-700" : "text-gray-700"}`}>Remaining to Bill</p>
            <p className={`text-2xl font-bold ${remainingToBill > 0 ? "text-purple-800" : "text-gray-800"}`}>{formatCurrency(remainingToBill, true)}</p>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default BillingSummaryCards;
